const devLocal = {
	endpoints: {
		API_URL: 'https://apiportest-grupoomint.msappproxy.net/api',
		PREGNANCYPLANNER_URL: 'http://localhost:3002',
		GUARDIA_URL: 'about:blank',
		TURNERA_URL: 'about:blank'
	},
	env: 'local',
	showDevTools: true,
	clarityProjectId: '0',
	apikey: 'AIzaSyBS2M009Ue6rv-AqlmV3E3u8pkgiij0dyo',
	cancelThresholdHours: 1
}

const remoteDev = {
	endpoints: {
		API_URL: 'http://172.16.4.161:4090/api',
		GUARDIA_URL: 'https://gsfronttest-grupoomint.msappproxy.net/',
		TURNERA_URL: 'https://turnerafronttest-grupoomint.msappproxy.net/'
	},
	env: 'remotedev',
	showDevTools: true,
	clarityProjectId: '0',
	apikey: 'AIzaSyBS2M009Ue6rv-AqlmV3E3u8pkgiij0dyo',
	cancelThresholdHours: 1
}

const remoteTest = {
	endpoints: {
		API_URL: 'https://apiportest-grupoomint.msappproxy.net/api',
		PREGNANCYPLANNER_URL: 'http://VDESA-TOTEMSGH:7000',
		GUARDIA_URL: 'https://gsfronttest-grupoomint.msappproxy.net/',
		TURNERA_URL: 'https://turnerafronttest-grupoomint.msappproxy.net/'
	},
	env: 'remotetest',
	showDevTools: true,
	clarityProjectId: '0',
	apikey: 'AIzaSyBS2M009Ue6rv-AqlmV3E3u8pkgiij0dyo',
	cancelThresholdHours: 0
}

const remotePreProd = {
	endpoints: {
		API_URL: 'http://172.16.4.161:8081/api',
		PREGNANCYPLANNER_URL: 'http://VDESA-TOTEMSGH:7001',
		GUARDIA_URL: 'https://gsfronttest-grupoomint.msappproxy.net/',
		TURNERA_URL: 'https://turnerafronttest-grupoomint.msappproxy.net/'
	},
	env: 'remotepreprod',
	showDevTools: true,
	clarityProjectId: '0',
	apikey: 'AIzaSyBS2M009Ue6rv-AqlmV3E3u8pkgiij0dyo',
	cancelThresholdHours: 0
}

const remoteProd = {
	endpoints: {
		API_URL: 'https://www.miportalclinicas.com.ar/backend/api',
		PREGNANCYPLANNER_URL: 'http://www.pregnancyplanner.com.ar',
		GUARDIA_URL: 'https://guardiasmart.miportalclinicas.com.ar/',
		TURNERA_URL: 'https://turnera.miportalclinicas.com.ar/'
	},
	env: 'remoteprod',
	showDevTools: false,
	clarityProjectId: 'vjx2k1gurn',
	apikey: 'AIzaSyBS2M009Ue6rv-AqlmV3E3u8pkgiij0dyo',
	cancelThresholdHours: 0
}

const firebaseDev = {
	vapidKey:
		'BJwhK8D_IMyWftqhg8UOGwyentyNABI4RHkjVI9hnVqFBcq8TPw8vgQoFV6lPYBGMMIUH2ajQLMu3EPArsMUHAs',
	web: {
		apiKey: 'AIzaSyBL9S7kO83OkyycxzxD_Y40SceNEjNrtqA',
		authDomain: 'omint-portal-clinicas-test.firebaseapp.com',
		projectId: 'omint-portal-clinicas-test',
		storageBucket: 'omint-portal-clinicas-test.firebasestorage.app',
		messagingSenderId: '269642821924',
		appId: '1:269642821924:web:235ddf0d118a7e056d43b1'
	}
}

const firebaseTest = {
	vapidKey:
		'BDwOswA7e1EwOfPFIuYBPFd7QRSQzajVoiE7a9rz05RP4WWnnizaDm0vUtOn6Cl3W3Wv_e-Bmu9vhonV-iDb3UY',
	web: {
		apiKey: 'AIzaSyDX2o8TqD5s9qwfkERgWQxKcWTg19Dr3fk',
		authDomain: 'omintprepagamobiledev.firebaseapp.com',
		databaseURL: 'https://omintprepagamobiledev.firebaseio.com',
		projectId: 'omintprepagamobiledev',
		storageBucket: 'omintprepagamobiledev.appspot.com',
		messagingSenderId: '655015374803',
		appId: '1:655015374803:web:54666f8beb48a431ccc926'
	}
}

const firebaseProd = {
	vapidKey:
		'BFBPLQkRgSfsdLG7GsyzmfcrO_4FlgoQquJCRFJxxouR7wFzBLHnsoY1PuCVahuno9ridFE7HXQD66kbGEMwOvs',
	web: {
		apiKey: 'AIzaSyDhcp1FMuQKD33yHcWiLaNbt6CsRTPbThY',
		authDomain: 'omintportalprod.firebaseapp.com',
		projectId: 'omintportalprod',
		storageBucket: 'omintportalprod.firebasestorage.app',
		messagingSenderId: '290635209707',
		appId: '1:290635209707:web:0af1854567436dd7ae57ae',
		measurementId: 'G-KBV0ZVFK16'
	}
}
const config =
	process.env.REACT_APP_STAGE === 'prod'
		? remoteProd
		: process.env.REACT_APP_STAGE === 'preprod'
		? remotePreProd
		: process.env.REACT_APP_STAGE === 'remotetest'
		? remoteTest
		: process.env.REACT_APP_STAGE === 'remotedev'
		? remoteDev
		: devLocal

const firebase =
	process.env.REACT_APP_STAGE === 'prod'
		? firebaseProd
		: process.env.REACT_APP_STAGE === 'preprod'
		? firebaseTest
		: process.env.REACT_APP_STAGE === 'remotetest'
		? firebaseTest
		: process.env.REACT_APP_STAGE === 'remotedev'
		? firebaseDev
		: firebaseDev

export default {
	...config,
	firebase
}
